/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetAxisRepresentation } from './WidgetAxisRepresentation';
import {
    WidgetAxisRepresentationFromJSON,
    WidgetAxisRepresentationFromJSONTyped,
    WidgetAxisRepresentationToJSON,
    WidgetAxisRepresentationToJSONTyped,
} from './WidgetAxisRepresentation';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface WidgetRepresentation
 */
export interface WidgetRepresentation {
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    dashboardKey: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    portfolioKey: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    generatedTitle: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    preset: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    type: string;
    /**
     * 
     * @type {Resolution}
     * @memberof WidgetRepresentation
     */
    resolution: Resolution;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    config: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetRepresentation
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetRepresentation
     */
    intervalName: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetRepresentation
     */
    intervalFrom: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetRepresentation
     */
    intervalTo: number;
    /**
     * 
     * @type {Array<WidgetAxisRepresentation>}
     * @memberof WidgetRepresentation
     */
    axis: Array<WidgetAxisRepresentation>;
}



/**
 * Check if a given object implements the WidgetRepresentation interface.
 */
export function instanceOfWidgetRepresentation(value: object): value is WidgetRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('dashboardKey' in value) || value['dashboardKey'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('generatedTitle' in value) || value['generatedTitle'] === undefined) return false;
    if (!('preset' in value) || value['preset'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('intervalName' in value) || value['intervalName'] === undefined) return false;
    if (!('intervalFrom' in value) || value['intervalFrom'] === undefined) return false;
    if (!('intervalTo' in value) || value['intervalTo'] === undefined) return false;
    if (!('axis' in value) || value['axis'] === undefined) return false;
    return true;
}

export function WidgetRepresentationFromJSON(json: any): WidgetRepresentation {
    return WidgetRepresentationFromJSONTyped(json, false);
}

export function WidgetRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'dashboardKey': json['dashboardKey'],
        'portfolioKey': json['portfolioKey'],
        'title': json['title'],
        'generatedTitle': json['generatedTitle'],
        'preset': json['preset'],
        'type': json['type'],
        'resolution': ResolutionFromJSON(json['resolution']),
        'config': json['config'],
        'position': json['position'],
        'intervalName': json['intervalName'],
        'intervalFrom': json['intervalFrom'],
        'intervalTo': json['intervalTo'],
        'axis': ((json['axis'] as Array<any>).map(WidgetAxisRepresentationFromJSON)),
    };
}

export function WidgetRepresentationToJSON(json: any): WidgetRepresentation {
    return WidgetRepresentationToJSONTyped(json, false);
}

export function WidgetRepresentationToJSONTyped(value?: WidgetRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'dashboardKey': value['dashboardKey'],
        'portfolioKey': value['portfolioKey'],
        'title': value['title'],
        'generatedTitle': value['generatedTitle'],
        'preset': value['preset'],
        'type': value['type'],
        'resolution': ResolutionToJSON(value['resolution']),
        'config': value['config'],
        'position': value['position'],
        'intervalName': value['intervalName'],
        'intervalFrom': value['intervalFrom'],
        'intervalTo': value['intervalTo'],
        'axis': ((value['axis'] as Array<any>).map(WidgetAxisRepresentationToJSON)),
    };
}

